module.exports = __webpack_public_path__ + "8c77635b6d5610b7641549137f8dfddc.svg";